import React from 'react';
import { $ } from '@starberry/components';
import { Routes } from '../../routes';
import AuthServices from 'core/services/store/auth/services';
import * as AuthActions from 'core/services/store/auth/actions';

import { Box, Divider, Flex, Icon } from '@chakra-ui/react';

export const DividerWithText = (props) => (
  <Flex align="center" color="gray.300" {...props}>
    <Box flex="1">
      <Divider borderColor="currentcolor" />
    </Box>
    <Box as="span" px="3" color={'gray.600'} fontWeight="medium">
      {props.children}
    </Box>
    <Box flex="1">
      <Divider borderColor="currentcolor" />
    </Box>
  </Flex>
);

export default {
  $: 'Box',
  props: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    bgImage: `url("${require('base/defaults/login-bg.jpg').default}")`,
    bgRepeat: 'no-repeat',
    bgSize: 'cover',
    bgPosition: 'center',
    minH: '100vh',
    py: 8,
    px: { sm: '6', lg: '8' },
    _after: {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'linear-gradient(transparent, rgba(0,0,0,0.7))',
      zIndex: '1',
    },
  },
  socialLoginBtnProps: {},
  subtitleLinkProps: {},
  children: ({ socialLoginBtnProps, subtitleLinkProps }) => [
    {
      $: 'Box',
      props: {
        position: 'relative',
        maxW: { sm: 'xl' },
        mx: { sm: 'auto' },
        w: { sm: 'full' },
        zIndex: 5,
      },
      children: [
        {
          $: 'Box',
          props: {
            bg: 'white',
            py: { base: '4', sm: '20' },
            px: { base: '8', sm: '24' },
            shadow: 'base',
            rounded: { sm: 'lg' },
          },
          children: [
            {
              $: 'H5',
              children: $(
                'constants.translations.signup.SIGNUP_TITLE',
                'Sign up with social media'
              ),
              props: {
                as: 'h2',
                pb: '2',
                textAlign: 'center',
              },
            },
            {
              $: 'Text',
              children: [
                {
                  $: 'Box',
                  props: { as: 'span' },
                  children: $(
                    'constants.translations.signup.SIGNUP_TITLE',
                    'Already have an account? '
                  ),
                },
                {
                  $: 'WrappedLink',
                  props: {
                    to: Routes.LoginPage,
                    ...subtitleLinkProps
                  },
                  children: $('constants.translations.login.LOGIN_SIGNUP_LINK', 'Login'),
                },
              ],
              props: {
                fontSize: '0.875rem',
                textAlign: 'center',
                mb: '8',
              },
            },
            {
              $: 'SimpleGrid',
              props: {
                mb: '6',
                columns: 2,
                spacing: '3',
              },
              children: [
                {
                  $: 'PrimaryButtonOutline',
                  provide: ['auth'],
                  color: 'currentColor',
                  borderRadius: '100px',
                  onClick: (_, context) => () => {
                    const [, dispatch] = context?.state?.auth || [];
                    AuthServices(AuthActions, dispatch).providerLogin('google');
                  },
                  ...socialLoginBtnProps,
                  children: [
                    { $: 'VisuallyHidden', children: 'Login with Google' },
                    { component: Icon, as: $('constants.icons.loginGoogle') },
                  ],
                },
                {
                  $: 'PrimaryButtonOutline',
                  provide: ['auth'],
                  color: 'currentColor',
                  borderRadius: '100px',
                  onClick: (_, context) => () => {
                    const [, dispatch] = context?.state?.auth || [];
                    AuthServices(AuthActions, dispatch).providerLogin('facebook');
                  },
                  ...socialLoginBtnProps,
                  children: [
                    { $: 'VisuallyHidden', children: 'Login with Facebook' },
                    { component: Icon, as: $('constants.icons.loginFacebook') },
                  ],
                },
              ],
            },
            {
              component: DividerWithText,
              props: { mb: '8', fontSize: '0.6875rem', color: 'rgb(189, 189, 189)' },
              children: $('constants.translations.login.SIGNUP_DIVIDER', 'or sign up with email'),
            },
            { $: 'SignUpForm' },
            { $: 'TermsForm' },
          ],
        },
      ],
    },
  ],
};
